import { SvgIcon, SvgIconProps } from "@mui/material";

export const PreservedIcon = ({ ...props }: SvgIconProps) => {
	return (
		<SvgIcon xmlns="http://www.w3.org/2000/svg" width="14" height="13" viewBox="0 0 14 13" fill="none" {...props}>
			<path
				d="M6.99924 0.5C8.55646 1.87772 10.5889 2.59504 12.6659 2.5C12.9683 3.52868 13.0608 4.60764 12.938 5.67279C12.8151 6.73793 12.4795 7.76751 11.9508 8.70035C11.4222 9.63319 10.7115 10.4503 9.86088 11.103C9.01025 11.7557 8.0371 12.2308 6.99924 12.5M6.99924 0.5C5.44202 1.87772 3.40959 2.59504 1.33257 2.5C1.03018 3.52868 0.93765 4.60764 1.06049 5.67279C1.18333 6.73793 1.51903 7.76751 2.04764 8.70035C2.57625 9.63319 3.28698 10.4503 4.1376 11.103C4.98823 11.7557 5.96138 12.2308 6.99924 12.5M6.99924 0.5L6.99924 12.5"
				stroke="#FAFAFA"
				strokeOpacity="0.85"
				strokeLinecap="round"
				strokeLinejoin="round"
				fill="none"
			/>
		</SvgIcon>
	);
};
